export const BASE_URL = 'https://api.eprocurements.ogunstate.gov.ng/api';